type StatLabelTextProps = {
  text: string;
  width: number;
  className?: string;
};

/** Figma stat labels — Matias 54, white + stroke #4D3C82. */
export function StatLabelText({ text, width, className }: StatLabelTextProps) {
  const baseline = 48;

  return (
    <svg
      className={className}
      width={width}
      height={60}
      viewBox={`0 0 ${width} 60`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <text
        className="stats-content__label-text"
        textAnchor="start"
        xmlSpace="preserve"
      >
        <tspan x={0} y={baseline}>
          {text}
        </tspan>
      </text>
    </svg>
  );
}
